var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoEndDate = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico_EndDate",
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_47325",
    "data-name": "Path 47325",
    d: "M30.222,193.732l-2.949-1.9-2.89,1.9a.794.794,0,0,0-.382.66v1.051h6.612V194.4A.806.806,0,0,0,30.222,193.732Zm0,0",
    transform: "translate(-23.26 -185.363)",
    fill: "#999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_47326",
    "data-name": "Path 47326",
    d: "M.054,0H7.946A.051.051,0,0,1,8,.047V1.279a.051.051,0,0,1-.054.047H.054A.051.051,0,0,1,0,1.279V.047A.051.051,0,0,1,.054,0Zm0,0",
    fill: "#999"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_47327",
    "data-name": "Path 47327",
    d: "M.054,323H7.946a.051.051,0,0,1,.054.047v1.232a.05.05,0,0,1-.054.047H.054A.05.05,0,0,1,0,324.279v-1.232A.051.051,0,0,1,.054,323Zm0,0",
    transform: "translate(0 -312.326)",
    fill: "#999"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_47328",
    "data-name": "Path 47328",
    d: "M23,57.965a.793.793,0,0,0,.371.652l2.935,1.992,2.935-1.992a.793.793,0,0,0,.371-.652V57H23Zm0,0",
    transform: "translate(-22.291 -55.079)",
    fill: "#999"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoEndDate);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_end_date.5ae1c3b13c4b202108e2d013a9f372da.svg";